export default {
  "authentication.login": { en: "Login", fa: "ورود به سامانه" },
  "authentication.social.sign-in": {
    en: "Sign in with social media",
    fa: "با رسانه های اجتماعی وارد شوید"
  },
  "authentication.forget-password": {
    en: "Forget Password",
    fa: "بازیابی رمز عبور"
  },
  "authentication.register": { en: "Register", fa: "ثبت نام" },
  "authentication.email": { en: "Email", fa: "ایمیل" },
  "authentication.name": { en: "Name", fa: "نام" },
  "authentication.password": { en: "Password", fa: "رمز‌عبور" },
  "authentication.required-name": {
    en: "Name is required",
    fa: "نام اجباری است"
  },
  "authentication.name-length": {
    en: "The maximum length of Name is 32",
    fa: "طول نام بیش از حد مجاز است (حداکثر 32 حرف مجاز است)"
  },
  "authentication.required-email": {
    en: "Email is required",
    fa: "ایمیل اجباری است"
  },
  "authentication.not-valid-email": {
    en: "Email is not valid",
    fa: "آدرس ایمیل معتبر نیست"
  },
  "authentication.email-length": {
    en: "The maximum length of Email is 64",
    fa: "طول ایمیل بیش از حد مجاز است (حداکثر 64 حرف مجاز است)"
  },
  "authentication.required-password": {
    en: "Password is required",
    fa: "رمز عبور اجباری است"
  },
  "authentication.password-length": {
    en: "The maximum length of Password is 128",
    fa: "طول پسورد بیش از حد مجاز است (حداکثر 128 حرف مجاز است)"
  }
};
